import React, { useEffect, useState } from "react";
import { IPlanSelectionStripeFormProps } from "./IPlanSelectionStripeFormProps";
// import { CardElement, injectStripe } from "react-stripe-elements";
import "./PlanSelectionStripeForm.scss";
import { toast } from "react-toastify";
import miscUtils from "../../../utils/miscUtils";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

const PlanSelectionStripeForm: React.FC<IPlanSelectionStripeFormProps> = props => {
  const {
    // stripe,
    getPayData,
    updateMemberCard,
    isUpdate,
    updateInfo,
    userEmail,
    // userFullName,
    billingAddress,
    theme,
    AddressInforRequired
  } = props;
  const [updatingCard, setUpdatingCardStatus] = useState<boolean>(false);
  const elements: any =  useElements();
  const stripe: any = useStripe();

  useEffect(() => {
    elements && elements.getElement("card").clear();
  }, [])

  const isDisabled = AddressInforRequired
  const finalBillingAddress = {
    ...(billingAddress && billingAddress.billing_details),
    // name: userFullName,
    email: userEmail
  };

  function handleOnChange() {
    const cardElement = elements && elements.getElement("card");
    stripe
      .createPaymentMethod({
        type: "card",
        card: cardElement,
        // billing_details: { name: userEmail }
        billing_details: finalBillingAddress
      })
      .then((paymentMethod: any) => {
        getPayData(paymentMethod);
      }).catch((error: any) => console.error(error))
  }

  function handleSubmit(e: any) {
    e.preventDefault();
    setUpdatingCardStatus(true);

    const cardElement = elements && elements.getElement("card");

    stripe
      .createPaymentMethod({
        type: "card",
        card: cardElement,
        // billing_details: { name: userEmail }
        billing_details: finalBillingAddress
      })
      .then((paymentMethod: any) => {
        if (paymentMethod.error) {
          updateInfo(false);
          getPayData(paymentMethod);
          toast("Invalid card information, please try again.", {
            type: 'error',
            autoClose: 3000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
        } else {
          if (paymentMethod && paymentMethod.paymentMethod) {
            updateInfo(true);
            getPayData(paymentMethod);
          }
          if (updateInfo) {
            updateMemberCard(paymentMethod);
          }
        }
      }).catch((error: any) => console.error(error))
  }

  function cancelCardInput() {
    updateInfo(true);
  }

  if (!isUpdate) {
    return (
      <form>
        <CardElement
          className="credit-card-form"
          // required={true}
          onChange={() => {
            handleOnChange();
          }}
          options={{
            hidePostalCode: true,
            disabled: isDisabled
          }}
        />
      </form>
    );
  }
  return (
    <form
      onSubmit={e => {
        handleSubmit(e);
      }}
    >
      <CardElement 
      className="credit-card-form" 
      // required={true}
      onChange={() => {
        handleOnChange();
      }}
      options={{
        hidePostalCode: true,
        disabled: isDisabled

      }}
      />
      <div className="buttons">
        <button
          style={miscUtils.getTextButtonStyle(theme)}
          type="button"
          onClick={() => {
            cancelCardInput();
          }}
        >
          Cancel
        </button>
        <button
          style={miscUtils.getTextButtonStyle(theme)}
          className={`${updatingCard ? "disabled" : ""}`} type="submit"
        >
          Save card
        </button>
      </div>
    </form>
  );
};

export default PlanSelectionStripeForm;
